"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AktionResponse = _interopRequireDefault(require("../model/AktionResponse"));
var _AuftragResponse = _interopRequireDefault(require("../model/AuftragResponse"));
var _Auftragsliste = _interopRequireDefault(require("../model/Auftragsliste"));
var _Besteller = _interopRequireDefault(require("../model/Besteller"));
var _EdelmetallKatalog = _interopRequireDefault(require("../model/EdelmetallKatalog"));
var _EdelmetallKonditionen = _interopRequireDefault(require("../model/EdelmetallKonditionen"));
var _EdelmetallKonditionenStufen = _interopRequireDefault(require("../model/EdelmetallKonditionenStufen"));
var _EdelmetallPreisResponse = _interopRequireDefault(require("../model/EdelmetallPreisResponse"));
var _EdelmetallWarenkorb = _interopRequireDefault(require("../model/EdelmetallWarenkorb"));
var _EdelmetallWarenkorbResponse = _interopRequireDefault(require("../model/EdelmetallWarenkorbResponse"));
var _FilialeLieferadresseChange = _interopRequireDefault(require("../model/FilialeLieferadresseChange"));
var _FilialenListe = _interopRequireDefault(require("../model/FilialenListe"));
var _HeaderRequest = _interopRequireDefault(require("../model/HeaderRequest"));
var _HeaderResponse = _interopRequireDefault(require("../model/HeaderResponse"));
var _KonditionChange = _interopRequireDefault(require("../model/KonditionChange"));
var _Kunde = _interopRequireDefault(require("../model/Kunde"));
var _KundeRequest = _interopRequireDefault(require("../model/KundeRequest"));
var _KundeResponse = _interopRequireDefault(require("../model/KundeResponse"));
var _Kursliste = _interopRequireDefault(require("../model/Kursliste"));
var _Login = _interopRequireDefault(require("../model/Login"));
var _LogonClientNext = _interopRequireDefault(require("../model/LogonClientNext"));
var _Mandant = _interopRequireDefault(require("../model/Mandant"));
var _MandantRequest = _interopRequireDefault(require("../model/MandantRequest"));
var _MitarbeiterKonditionenRequest = _interopRequireDefault(require("../model/MitarbeiterKonditionenRequest"));
var _OrderStatus = _interopRequireDefault(require("../model/OrderStatus"));
var _Orders = _interopRequireDefault(require("../model/Orders"));
var _RequestAction = _interopRequireDefault(require("../model/RequestAction"));
var _Session = _interopRequireDefault(require("../model/Session"));
var _SortenKatalog = _interopRequireDefault(require("../model/SortenKatalog"));
var _SortenKonditionen = _interopRequireDefault(require("../model/SortenKonditionen"));
var _SortenKonditionenStufen = _interopRequireDefault(require("../model/SortenKonditionenStufen"));
var _SortenKursResponse = _interopRequireDefault(require("../model/SortenKursResponse"));
var _SortenWarenkorb = _interopRequireDefault(require("../model/SortenWarenkorb"));
var _SortenWarenkorbResponse = _interopRequireDefault(require("../model/SortenWarenkorbResponse"));
var _StammdatenResponse = _interopRequireDefault(require("../model/StammdatenResponse"));
var _TanAuthRequest = _interopRequireDefault(require("../model/TanAuthRequest"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Default service.
* @module api/DefaultApi
* @version 1.0.44
*/
var DefaultApi = exports.default = /*#__PURE__*/function () {
  /**
  * Constructs a new DefaultApi.
  * @alias module:api/DefaultApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function DefaultApi(apiClient) {
    _classCallCheck(this, DefaultApi);
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the action operation.
   * @callback module:api/DefaultApi~actionCallback
   * @param {String} error Error message, if any.
   * @param {module:model/AktionResponse} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Storno eines Auftrags
   * Stornieren Eines Auftrags, wenn er im Zeitrahmen liegt
   * @param {Number} mandantId ID des Mandanten
   * @param {Number} auftragsNummer ID des Auftrags
   * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
   * @param {module:model/RequestAction} requestAction
   * @param {module:api/DefaultApi~actionCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/AktionResponse}
   */
  return _createClass(DefaultApi, [{
    key: "action",
    value: function action(mandantId, auftragsNummer, request, requestAction, callback) {
      var postBody = requestAction;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling action");
      }
      // verify the required parameter 'auftragsNummer' is set
      if (auftragsNummer === undefined || auftragsNummer === null) {
        throw new Error("Missing the required parameter 'auftragsNummer' when calling action");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling action");
      }
      // verify the required parameter 'requestAction' is set
      if (requestAction === undefined || requestAction === null) {
        throw new Error("Missing the required parameter 'requestAction' when calling action");
      }
      var pathParams = {
        'mandantId': mandantId,
        'auftragsNummer': auftragsNummer
      };
      var queryParams = {};
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AktionResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/auftrag/{auftragsNummer}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the addEmOrder operation.
     * @callback module:api/DefaultApi~addEmOrderCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderStatus} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} angebotsId Nummer des aktuellen Angebots
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/Orders} orders
     * @param {module:api/DefaultApi~addEmOrderCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderStatus}
     */
  }, {
    key: "addEmOrder",
    value: function addEmOrder(angebotsId, mandantId, orders, callback) {
      var postBody = orders;
      // verify the required parameter 'angebotsId' is set
      if (angebotsId === undefined || angebotsId === null) {
        throw new Error("Missing the required parameter 'angebotsId' when calling addEmOrder");
      }
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling addEmOrder");
      }
      // verify the required parameter 'orders' is set
      if (orders === undefined || orders === null) {
        throw new Error("Missing the required parameter 'orders' when calling addEmOrder");
      }
      var pathParams = {
        'angebotsId': angebotsId,
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _OrderStatus.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/warenkorb/order/{angebotsId}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the addEmTanOrder operation.
     * @callback module:api/DefaultApi~addEmTanOrderCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} angebotsId Nummer des aktuellen Angebots
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/Orders} orders
     * @param {module:api/DefaultApi~addEmTanOrderCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "addEmTanOrder",
    value: function addEmTanOrder(angebotsId, mandantId, orders, callback) {
      var postBody = orders;
      // verify the required parameter 'angebotsId' is set
      if (angebotsId === undefined || angebotsId === null) {
        throw new Error("Missing the required parameter 'angebotsId' when calling addEmTanOrder");
      }
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling addEmTanOrder");
      }
      // verify the required parameter 'orders' is set
      if (orders === undefined || orders === null) {
        throw new Error("Missing the required parameter 'orders' when calling addEmTanOrder");
      }
      var pathParams = {
        'angebotsId': angebotsId,
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/warenkorb/orderMitTan/{angebotsId}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the addKunde operation.
     * @callback module:api/DefaultApi~addKundeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/KundeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Kundendaten anlegen
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Number} kundeId ID des Kunden
     * @param {module:model/Kunde} kunde
     * @param {module:api/DefaultApi~addKundeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/KundeResponse}
     */
  }, {
    key: "addKunde",
    value: function addKunde(mandantId, kundeId, kunde, callback) {
      var postBody = kunde;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling addKunde");
      }
      // verify the required parameter 'kundeId' is set
      if (kundeId === undefined || kundeId === null) {
        throw new Error("Missing the required parameter 'kundeId' when calling addKunde");
      }
      // verify the required parameter 'kunde' is set
      if (kunde === undefined || kunde === null) {
        throw new Error("Missing the required parameter 'kunde' when calling addKunde");
      }
      var pathParams = {
        'mandantId': mandantId,
        'kundeId': kundeId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _KundeResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/kunde/{kundeId}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the addMandantFile operation.
     * @callback module:api/DefaultApi~addMandantFileCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId Id des Mandanten
     * @param {String} filename Name der Datei als URLencoded latin1 String
     * @param {Object} opts Optional parameters
     * @param {Number} [fileId] ID des Files
     * @param {Number} [fileOrder] Position in der Reihenfolge der Dateien
     * @param {module:api/DefaultApi~addMandantFileCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "addMandantFile",
    value: function addMandantFile(mandantId, filename, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling addMandantFile");
      }
      // verify the required parameter 'filename' is set
      if (filename === undefined || filename === null) {
        throw new Error("Missing the required parameter 'filename' when calling addMandantFile");
      }
      var pathParams = {};
      var queryParams = {
        'mandantId': mandantId,
        'fileId': opts['fileId'],
        'filename': filename,
        'fileOrder': opts['fileOrder']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['multipart/form-data'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/rage/mandantFileUpload', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the addSoOrder operation.
     * @callback module:api/DefaultApi~addSoOrderCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HeaderResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Number} angebotsId angebotsId aus warenkorb identifizier den Auftrag
     * @param {module:model/Besteller} besteller
     * @param {module:api/DefaultApi~addSoOrderCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/HeaderResponse}
     */
  }, {
    key: "addSoOrder",
    value: function addSoOrder(mandantId, angebotsId, besteller, callback) {
      var postBody = besteller;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling addSoOrder");
      }
      // verify the required parameter 'angebotsId' is set
      if (angebotsId === undefined || angebotsId === null) {
        throw new Error("Missing the required parameter 'angebotsId' when calling addSoOrder");
      }
      // verify the required parameter 'besteller' is set
      if (besteller === undefined || besteller === null) {
        throw new Error("Missing the required parameter 'besteller' when calling addSoOrder");
      }
      var pathParams = {
        'mandantId': mandantId,
        'angebotsId': angebotsId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _HeaderResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/warenkorb/order/{angebotsId}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the addSoTanOrder operation.
     * @callback module:api/DefaultApi~addSoTanOrderCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} angebotsId Nummer des aktuellen Angebots
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/Orders} orders
     * @param {module:api/DefaultApi~addSoTanOrderCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "addSoTanOrder",
    value: function addSoTanOrder(angebotsId, mandantId, orders, callback) {
      var postBody = orders;
      // verify the required parameter 'angebotsId' is set
      if (angebotsId === undefined || angebotsId === null) {
        throw new Error("Missing the required parameter 'angebotsId' when calling addSoTanOrder");
      }
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling addSoTanOrder");
      }
      // verify the required parameter 'orders' is set
      if (orders === undefined || orders === null) {
        throw new Error("Missing the required parameter 'orders' when calling addSoTanOrder");
      }
      var pathParams = {
        'angebotsId': angebotsId,
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/warenkorb/orderMitTan/{angebotsId}/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the changeEmKondition operation.
     * @callback module:api/DefaultApi~changeEmKonditionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HeaderResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Ändern einer Kondition eines Produkts
     * @param {Number} mandantId Id des Mandanten
     * @param {Number} kennziffer Kennziffer des Edelmetalls
     * @param {module:model/KonditionChange} konditionChange
     * @param {Object} opts Optional parameters
     * @param {String} [request] Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~changeEmKonditionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/HeaderResponse}
     */
  }, {
    key: "changeEmKondition",
    value: function changeEmKondition(mandantId, kennziffer, konditionChange, opts, callback) {
      opts = opts || {};
      var postBody = konditionChange;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling changeEmKondition");
      }
      // verify the required parameter 'kennziffer' is set
      if (kennziffer === undefined || kennziffer === null) {
        throw new Error("Missing the required parameter 'kennziffer' when calling changeEmKondition");
      }
      // verify the required parameter 'konditionChange' is set
      if (konditionChange === undefined || konditionChange === null) {
        throw new Error("Missing the required parameter 'konditionChange' when calling changeEmKondition");
      }
      var pathParams = {
        'mandantId': mandantId,
        'kennziffer': kennziffer
      };
      var queryParams = {};
      var headerParams = {
        'request': opts['request']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _HeaderResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/konditionenProdukt/{kennziffer}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the changeSoKondition operation.
     * @callback module:api/DefaultApi~changeSoKonditionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HeaderResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * ändert eine Kondition
     * @param {Number} mandantId Id des Mandanten
     * @param {Number} kennziffer Kennziffer des Produkts
     * @param {module:model/KonditionChange} konditionChange
     * @param {module:api/DefaultApi~changeSoKonditionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/HeaderResponse}
     */
  }, {
    key: "changeSoKondition",
    value: function changeSoKondition(mandantId, kennziffer, konditionChange, callback) {
      var postBody = konditionChange;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling changeSoKondition");
      }
      // verify the required parameter 'kennziffer' is set
      if (kennziffer === undefined || kennziffer === null) {
        throw new Error("Missing the required parameter 'kennziffer' when calling changeSoKondition");
      }
      // verify the required parameter 'konditionChange' is set
      if (konditionChange === undefined || konditionChange === null) {
        throw new Error("Missing the required parameter 'konditionChange' when calling changeSoKondition");
      }
      var pathParams = {
        'mandantId': mandantId,
        'kennziffer': kennziffer
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _HeaderResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/konditionenProdukt/{kennziffer}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the deleteEmKondition operation.
     * @callback module:api/DefaultApi~deleteEmKonditionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HeaderResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Löscht den Wert in den Konditionen
     * @param {Number} mandantId Id des Mandanten
     * @param {module:model/String} kennziffer Wert im Datensatz
     * @param {module:api/DefaultApi~deleteEmKonditionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/HeaderResponse}
     */
  }, {
    key: "deleteEmKondition",
    value: function deleteEmKondition(mandantId, kennziffer, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling deleteEmKondition");
      }
      // verify the required parameter 'kennziffer' is set
      if (kennziffer === undefined || kennziffer === null) {
        throw new Error("Missing the required parameter 'kennziffer' when calling deleteEmKondition");
      }
      var pathParams = {
        'mandantId': mandantId,
        'kennziffer': kennziffer
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _HeaderResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/konditionenProdukt/{kennziffer}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the deleteMandantFile operation.
     * @callback module:api/DefaultApi~deleteMandantFileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HeaderResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Number} fileId
     * @param {module:api/DefaultApi~deleteMandantFileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/HeaderResponse}
     */
  }, {
    key: "deleteMandantFile",
    value: function deleteMandantFile(mandantId, fileId, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling deleteMandantFile");
      }
      // verify the required parameter 'fileId' is set
      if (fileId === undefined || fileId === null) {
        throw new Error("Missing the required parameter 'fileId' when calling deleteMandantFile");
      }
      var pathParams = {
        'mandantId': mandantId,
        'fileId': fileId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _HeaderResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/mandantFile/{fileId}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the deleteSoKondition operation.
     * @callback module:api/DefaultApi~deleteSoKonditionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HeaderResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Löscht den Wert in den Konditionen
     * @param {Number} mandantId Id des Mandanten
     * @param {module:model/String} kennziffer Wert im Datensatz
     * @param {module:api/DefaultApi~deleteSoKonditionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/HeaderResponse}
     */
  }, {
    key: "deleteSoKondition",
    value: function deleteSoKondition(mandantId, kennziffer, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling deleteSoKondition");
      }
      // verify the required parameter 'kennziffer' is set
      if (kennziffer === undefined || kennziffer === null) {
        throw new Error("Missing the required parameter 'kennziffer' when calling deleteSoKondition");
      }
      var pathParams = {
        'mandantId': mandantId,
        'kennziffer': kennziffer
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _HeaderResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/konditionenProdukt/{kennziffer}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the editKunde operation.
     * @callback module:api/DefaultApi~editKundeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/KundeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Ändere die Kundendaten
     * wird in Kundenshop verwendet, um die Daten nach dem OAuth Login anzureichern
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Number} kundeId ID des Kunden
     * @param {module:model/KundeRequest} kundeRequest JSON mit den Kundendaten
     * @param {module:api/DefaultApi~editKundeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/KundeResponse}
     */
  }, {
    key: "editKunde",
    value: function editKunde(mandantId, kundeId, kundeRequest, callback) {
      var postBody = kundeRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling editKunde");
      }
      // verify the required parameter 'kundeId' is set
      if (kundeId === undefined || kundeId === null) {
        throw new Error("Missing the required parameter 'kundeId' when calling editKunde");
      }
      // verify the required parameter 'kundeRequest' is set
      if (kundeRequest === undefined || kundeRequest === null) {
        throw new Error("Missing the required parameter 'kundeRequest' when calling editKunde");
      }
      var pathParams = {
        'mandantId': mandantId,
        'kundeId': kundeId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _KundeResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/kunde/{kundeId}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getAuftrag operation.
     * @callback module:api/DefaultApi~getAuftragCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AuftragResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die Details eines Auftrags
     * @param {Number} mandantId ID des Mandanten
     * @param {Number} auftragsNummer ID des Auftrags
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~getAuftragCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AuftragResponse}
     */
  }, {
    key: "getAuftrag",
    value: function getAuftrag(mandantId, auftragsNummer, request, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getAuftrag");
      }
      // verify the required parameter 'auftragsNummer' is set
      if (auftragsNummer === undefined || auftragsNummer === null) {
        throw new Error("Missing the required parameter 'auftragsNummer' when calling getAuftrag");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling getAuftrag");
      }
      var pathParams = {
        'mandantId': mandantId,
        'auftragsNummer': auftragsNummer
      };
      var queryParams = {};
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AuftragResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/auftrag/{auftragsNummer}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getAuftragList operation.
     * @callback module:api/DefaultApi~getAuftragListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Auftragsliste} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {Object} opts Optional parameters
     * @param {String} [kennziffer] ID aus dem Katalog der Edelmetalle bzw. Sorten (KENNZ)
     * @param {String} [iso] ISO Code einer Währung bei Sorten. Die möglichen Ausprägungen werden aus der DB geliefert (ISOCODE) nur bei VerseNeo
     * @param {String} [text] Langbezeichnug des Produkts (LANGTEXT) nur bei VerseNeo. 30 Zeichen
     * @param {Number} [auftragsStatus] aktueller Status des Auftrags (AUFTRAGSTATUS) 1             Order erfasst, Ware noch nicht geliefert (bei Ankäufen) 2             Order bereit zur Abrechnung 3             Order an secore übertragen 4             Abrechnung in secore fehlerhaft 5             Order in secore erfolgreich abgerechnet 6             Storno durchgeführt      9             vorgemerkt zum Storno intern bei der BayernLB 70           TCM-Prüfung läuft 71           gesperrt wg. TCM-Prüfung
     * @param {module:model/String} [geschaeftsart] Ankauf oder Verkauf bei Edelmetall oder Sorten (GVARTNR)
     * @param {String} [kundenkonto] Kontonummer des Kunden (KONTO)
     * @param {Date} [datumVon] Startdatum der Suche (DATUMVON)
     * @param {Date} [datumBis] Endedatum der Suche (DATUMBIS)
     * @param {Number} [euroVon] Untere Grenze für den Euro-Gegenwert des Auftrags (VONBETR) nur bei VerseNeo
     * @param {Number} [euroBis] Obere Grenze für den Euro-Gegenwert des Auftrags (BISBETR) nur bei VerseNeo
     * @param {Number} [auftragsNummer] Nummer des Auftrags (AUFTRAGNR)
     * @param {Number} [auftragsNummerStart] die Auftragsnummer ist größer oder gleich der Nummer (START_AUFTRAG) nur bei VerseNeo
     * @param {String} [personenNummer] // Nummer der Person, für die der Auftrag gesucht werden soll
     * @param {String} [erfasserFiliale] // ID der Filiale, in der die gesuchten Aufträge erfasst wurden     
     * @param {String} [iban] // IBAN des Kundenkontos
     * @param {module:api/DefaultApi~getAuftragListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Auftragsliste}
     */
  }, {
    key: "getAuftragList",
    value: function getAuftragList(mandantId, request, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getAuftragList");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling getAuftragList");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'kennziffer': opts['kennziffer'],
        'iso': opts['iso'],
        'text': opts['text'],
        'auftragsStatus': opts['auftragsStatus'],
        'geschaeftsart': opts['geschaeftsart'],
        'kundenkonto': opts['kundenkonto'],
        'datumVon': opts['datumVon'],
        'datumBis': opts['datumBis'],
        'euroVon': opts['euroVon'],
        'euroBis': opts['euroBis'],
        'auftragsNummer': opts['auftragsNummer'],
        'auftragsNummerStart': opts['auftragsNummerStart'],
        'personenNummer': opts['personenNummer'],
        'erfasserFiliale': opts['erfasserFiliale'],
        'iban': opts['iban']
      };
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Auftragsliste.default;
      return this.apiClient.callApi('/rage/{mandantId}/auftragsuebersicht', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getAuftragPdf operation.
     * @callback module:api/DefaultApi~getAuftragPdfCallback
     * @param {String} error Error message, if any.
     * @param {Blob} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die zum Mandanten gehörende PDF für eine Auftrag
     * @param {Number} mandantId ID des Mandanten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {Number} auftragsNummer ID des Auftrags
     * @param {module:api/DefaultApi~getAuftragPdfCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Blob}
     */
  }, {
    key: "getAuftragPdf",
    value: function getAuftragPdf(mandantId, request, auftragsNummer, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getAuftragPdf");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling getAuftragPdf");
      }
      // verify the required parameter 'auftragsNummer' is set
      if (auftragsNummer === undefined || auftragsNummer === null) {
        throw new Error("Missing the required parameter 'auftragsNummer' when calling getAuftragPdf");
      }
      var pathParams = {
        'mandantId': mandantId,
        'auftragsNummer': auftragsNummer
      };
      var queryParams = {};
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/pdf'];
      var returnType = 'Blob';
      return this.apiClient.callApi('/rage/{mandantId}/auftragPdf/{auftragsNummer}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getEdelmetallBild operation.
     * @callback module:api/DefaultApi~getEdelmetallBildCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * gole die Bilddaten zu einem Item
     * @param {Number} mandantId Kennung des Mandanten
     * @param {String} bildName Basisname des Bildes ohne Endung
     * @param {module:api/DefaultApi~getEdelmetallBildCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "getEdelmetallBild",
    value: function getEdelmetallBild(mandantId, bildName, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getEdelmetallBild");
      }
      // verify the required parameter 'bildName' is set
      if (bildName === undefined || bildName === null) {
        throw new Error("Missing the required parameter 'bildName' when calling getEdelmetallBild");
      }
      var pathParams = {
        'mandantId': mandantId,
        'bildName': bildName
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/bild/{bildName}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getEdelmetallInfo operation.
     * @callback module:api/DefaultApi~getEdelmetallInfoCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * hold die Wichtigen Hinweise von FirstSpirit
     * die HTML-Seite für wichtige Infos wird aus FirstSpirit gelesen und zurückhegeben
     * @param {module:api/DefaultApi~getEdelmetallInfoCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "getEdelmetallInfo",
    value: function getEdelmetallInfo(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain'];
      var returnType = null;
      return this.apiClient.callApi('/rage/edelmetallInfo', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getEmKatalog operation.
     * @callback module:api/DefaultApi~getEmKatalogCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EdelmetallKatalog} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:api/DefaultApi~getEmKatalogCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EdelmetallKatalog}
     */
  }, {
    key: "getEmKatalog",
    value: function getEmKatalog(mandantId, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getEmKatalog");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _EdelmetallKatalog.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/katalog', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getEmKonditionen operation.
     * @callback module:api/DefaultApi~getEmKonditionenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EdelmetallKonditionen} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Object} opts Optional parameters
     * @param {String} [request] Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {Number} [gpNummer] Geschäftspartner Nummer des Mandanten, der als BLBAdmin geladen werden soll
     * @param {module:api/DefaultApi~getEmKonditionenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EdelmetallKonditionen}
     */
  }, {
    key: "getEmKonditionen",
    value: function getEmKonditionen(mandantId, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getEmKonditionen");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'GpNummer': opts['gpNummer']
      };
      var headerParams = {
        'request': opts['request']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _EdelmetallKonditionen.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/konditionenProdukt', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getEmKonditionenStufen operation.
     * @callback module:api/DefaultApi~getEmKonditionenStufenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EdelmetallKonditionenStufen} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Object} opts Optional parameters
     * @param {Number} [gpNummer] Geschäftspartner Nummer des Mandanten, der als BLBAdmin geladen werden soll
     * @param {module:api/DefaultApi~getEmKonditionenStufenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EdelmetallKonditionenStufen}
     */
  }, {
    key: "getEmKonditionenStufen",
    value: function getEmKonditionenStufen(mandantId, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getEmKonditionenStufen");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'GpNummer': opts['gpNummer']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _EdelmetallKonditionenStufen.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/konditionenStufen', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getEmKursList operation.
     * @callback module:api/DefaultApi~getEmKursListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Kursliste} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~getEmKursListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Kursliste}
     */
  }, {
    key: "getEmKursList",
    value: function getEmKursList(mandantId, request, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getEmKursList");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling getEmKursList");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Kursliste.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/kursListe', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getEmKursListePdf operation.
     * @callback module:api/DefaultApi~getEmKursListePdfCallback
     * @param {String} error Error message, if any.
     * @param {Blob} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die zum Mandanten gehörende Kursliste als PDF
     * @param {Number} mandantId ID des Mandanten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {String} opts query parameters
     * @param {module:api/DefaultApi~getEmKursListePdfCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Blob}
     */
  }, {
    key: "getEmKursListePdf",
    value: function getEmKursListePdf(mandantId, request, opts, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getEmKursListePdf");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling getEmKursListePdf");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'kind': opts['kind'],
        'make': opts['make']
      };
      console.log('DefaultApi.getEmKursListePdf - opts:', opts, 'queryParams:', queryParams);
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/pdf'];
      var returnType = 'Blob';
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/kursListePdf', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getEmPreis operation.
     * @callback module:api/DefaultApi~getEmPreisCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EdelmetallPreisResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Object} opts Optional parameters
     * @param {Boolean} [isMaKond] Gibt an, ob die Mitarbeiterkonditionen geholt werden sollen
     * @param {module:api/DefaultApi~getEmPreisCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EdelmetallPreisResponse}
     */
  }, {
    key: "getEmPreis",
    value: function getEmPreis(mandantId, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getEmPreis");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'isMaKond': opts['isMaKond']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _EdelmetallPreisResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/preis', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getKunde operation.
     * @callback module:api/DefaultApi~getKundeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/KundeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Number} kundeId ID des Kunden
     * @param {module:api/DefaultApi~getKundeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/KundeResponse}
     */
  }, {
    key: "getKunde",
    value: function getKunde(mandantId, kundeId, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getKunde");
      }
      // verify the required parameter 'kundeId' is set
      if (kundeId === undefined || kundeId === null) {
        throw new Error("Missing the required parameter 'kundeId' when calling getKunde");
      }
      var pathParams = {
        'mandantId': mandantId,
        'kundeId': kundeId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _KundeResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/kunde/{kundeId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getKundeWithHeader operation.
     * @callback module:api/DefaultApi~getKundeWithHeaderCallback
     * @param {String} error Error message, if any.
     * @param {module:model/KundeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Number} kundeId ID des Kunden
     * @param {module:model/HeaderRequest} headerRequest
     * @param {module:api/DefaultApi~getKundeWithHeaderCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/KundeResponse}
     */
  }, {
    key: "getKundeWithHeader",
    value: function getKundeWithHeader(mandantId, kundeId, headerRequest, callback) {
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getKundeWithHeader");
      }
      // verify the required parameter 'kundeId' is set
      if (kundeId === undefined || kundeId === null) {
        throw new Error("Missing the required parameter 'kundeId' when calling getKundeWithHeader");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling getKundeWithHeader");
      }
      var pathParams = {
        'mandantId': mandantId,
        'kundeId': kundeId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _KundeResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/kunde/{kundeId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getKundenListe operation.
     * @callback module:api/DefaultApi~getKundenListeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/KundeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:api/DefaultApi~getKundenListeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/KundeResponse}
     */
  }, {
    key: "getKundenListe",
    value: function getKundenListe(mandantId, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getKundenListe");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _KundeResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/kunde', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getLieferadressenList operation.
     * @callback module:api/DefaultApi~getLieferadressenListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FilialenListe} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die Liste der Lieferadressen der Filialen
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~getLieferadressenListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FilialenListe}
     */
  }, {
    key: "getLieferadressenList",
    value: function getLieferadressenList(mandantId, request, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getLieferadressenList");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling getLieferadressenList");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _FilialenListe.default;
      return this.apiClient.callApi('/rage/{mandantId}/lieferadressen', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getMandant operation.
     * @callback module:api/DefaultApi~getMandantCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Mandant} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:api/DefaultApi~getMandantCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Mandant}
     */
  }, {
    key: "getMandant",
    value: function getMandant(mandantId, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getMandant");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Mandant.default;
      return this.apiClient.callApi('/rage/{mandantId}/mandant', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getMandantByGp operation.
     * @callback module:api/DefaultApi~getMandantByGpCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Mandant} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {String} gpNummer GP Nummer des Mandanten
     * @param {module:api/DefaultApi~getMandantByGpCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Mandant}
     */
  }, {
    key: "getMandantByGp",
    value: function getMandantByGp(mandantId, gpNummer, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getMandantByGp");
      }
      // verify the required parameter 'gpNummer' is set
      if (gpNummer === undefined || gpNummer === null) {
        throw new Error("Missing the required parameter 'gpNummer' when calling getMandantByGp");
      }
      var pathParams = {
        'mandantId': mandantId,
        'GpNummer': gpNummer
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Mandant.default;
      return this.apiClient.callApi('/rage/{mandantId}/mandant/{GpNummer}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getMandantImageDownload operation.
     * @callback module:api/DefaultApi~getMandantImageDownloadCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * hole Bildaten des Mandanten
     * @param {Number} mandantId Kennung des Mandanten
     * @param {module:model/String} imageType Typ des Bildes (Logo oder Kontactbild)
     * @param {module:api/DefaultApi~getMandantImageDownloadCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "getMandantImageDownload",
    value: function getMandantImageDownload(mandantId, imageType, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getMandantImageDownload");
      }
      // verify the required parameter 'imageType' is set
      if (imageType === undefined || imageType === null) {
        throw new Error("Missing the required parameter 'imageType' when calling getMandantImageDownload");
      }
      var pathParams = {};
      var queryParams = {
        'mandantId': mandantId,
        'imageType': imageType
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/rage/mandantImageDownload', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getOrderPdf operation.
     * @callback module:api/DefaultApi~getOrderPdfCallback
     * @param {String} error Error message, if any.
     * @param {Blob} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die zur Order gehörende PDF
     * @param {Number} orderId Kennung der order
     * @param {Number} mandantId ID des Mandanten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~getOrderPdfCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Blob}
     */
  }, {
    key: "getOrderPdf",
    value: function getOrderPdf(orderId, mandantId, request, callback) {
      var postBody = null;
      // verify the required parameter 'orderId' is set
      if (orderId === undefined || orderId === null) {
        throw new Error("Missing the required parameter 'orderId' when calling getOrderPdf");
      }
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getOrderPdf");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling getOrderPdf");
      }
      var pathParams = {
        'orderId': orderId,
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/pdf'];
      var returnType = 'Blob';
      return this.apiClient.callApi('/rage/{mandantId}/order/orderPdf/{orderId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getSession operation.
     * @callback module:api/DefaultApi~getSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Session} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des Mandanten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~getSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Session}
     */
  }, {
    key: "getSession",
    value: function getSession(mandantId, request, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getSession");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling getSession");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {
        'Request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Session.default;
      return this.apiClient.callApi('/rage/{mandantId}/session', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getSoKatalog operation.
     * @callback module:api/DefaultApi~getSoKatalogCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SortenKatalog} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:api/DefaultApi~getSoKatalogCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SortenKatalog}
     */
  }, {
    key: "getSoKatalog",
    value: function getSoKatalog(mandantId, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getSoKatalog");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SortenKatalog.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/katalog', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getSoKonditionen operation.
     * @callback module:api/DefaultApi~getSoKonditionenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SortenKonditionen} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Object} opts Optional parameters
     * @param {Number} [gpNummer] Geschäftspartner Nummer des Mandanten, der als BLBAdmin geladen werden soll
     * @param {module:api/DefaultApi~getSoKonditionenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SortenKonditionen}
     */
  }, {
    key: "getSoKonditionen",
    value: function getSoKonditionen(mandantId, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getSoKonditionen");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'GpNummer': opts['gpNummer']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SortenKonditionen.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/konditionenProdukt', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getSoKonditionenStufen operation.
     * @callback module:api/DefaultApi~getSoKonditionenStufenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SortenKonditionenStufen} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Object} opts Optional parameters
     * @param {Number} [gpNummer] Geschäftspartner Nummer des Mandanten, der als BLBAdmin geladen werden soll
     * @param {module:api/DefaultApi~getSoKonditionenStufenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SortenKonditionenStufen}
     */
  }, {
    key: "getSoKonditionenStufen",
    value: function getSoKonditionenStufen(mandantId, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getSoKonditionenStufen");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'GpNummer': opts['gpNummer']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SortenKonditionenStufen.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/konditionenStufen', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getSoKurs operation.
     * @callback module:api/DefaultApi~getSoKursCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SortenKursResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Object} opts Optional parameters
     * @param {Boolean} [isMaKond] Gibt an, ob die Mitarbeiterkonditionen geholt werden sollen
     * @param {module:api/DefaultApi~getSoKursCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SortenKursResponse}
     */
  }, {
    key: "getSoKurs",
    value: function getSoKurs(mandantId, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getSoKurs");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'isMaKond': opts['isMaKond']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SortenKursResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/kurs', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getSoKursList operation.
     * @callback module:api/DefaultApi~getSoKursListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Kursliste} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~getSoKursListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Kursliste}
     */
  }, {
    key: "getSoKursList",
    value: function getSoKursList(mandantId, request, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getSoKursList");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling getSoKursList");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Kursliste.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/kursListe', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getSoKursListePdf operation.
     * @callback module:api/DefaultApi~getSoKursListePdfCallback
     * @param {String} error Error message, if any.
     * @param {Blob} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die zum Mandanten gehörende Kursliste als PDF
     * @param {Number} mandantId ID des Mandanten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~getSoKursListePdfCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Blob}
     */
  }, {
    key: "getSoKursListePdf",
    value: function getSoKursListePdf(mandantId, request, opts, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getSoKursListePdf");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling getSoKursListePdf");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'kind': opts['kind'],
        'make': opts['make']
      };
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/pdf'];
      var returnType = 'Blob';
      return this.apiClient.callApi('/rage/{mandantId}/sorten/kursListePdf', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getSoOrder operation.
     * @callback module:api/DefaultApi~getSoOrderCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderStatus} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Number} angebotsId angebotsId aus warenkorb identifizier den Auftrag
     * @param {module:api/DefaultApi~getSoOrderCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderStatus}
     */
  }, {
    key: "getSoOrder",
    value: function getSoOrder(mandantId, angebotsId, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getSoOrder");
      }
      // verify the required parameter 'angebotsId' is set
      if (angebotsId === undefined || angebotsId === null) {
        throw new Error("Missing the required parameter 'angebotsId' when calling getSoOrder");
      }
      var pathParams = {
        'mandantId': mandantId,
        'angebotsId': angebotsId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _OrderStatus.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/warenkorb/order/{angebotsId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getSortenInfo operation.
     * @callback module:api/DefaultApi~getSortenInfoCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * hold die Wichtigen Hinweise von FirstSpirit
     * die HTML-Seite für wichtige Infos wird aus FirstSpirit gelesen und zurückhegeben
     * @param {module:api/DefaultApi~getSortenInfoCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "getSortenInfo",
    value: function getSortenInfo(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain'];
      var returnType = null;
      return this.apiClient.callApi('/rage/sortenInfo', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getSotenBild operation.
     * @callback module:api/DefaultApi~getSotenBildCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * hole die Bilddaten zu einem Item
     * @param {Number} mandantId Kennung des Mandanten
     * @param {String} bildName Basisname des Bildes ohne Endung
     * @param {module:api/DefaultApi~getSotenBildCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "getSotenBild",
    value: function getSotenBild(mandantId, bildName, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getSotenBild");
      }
      // verify the required parameter 'bildName' is set
      if (bildName === undefined || bildName === null) {
        throw new Error("Missing the required parameter 'bildName' when calling getSotenBild");
      }
      var pathParams = {
        'mandantId': mandantId,
        'bildName': bildName
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/bild/{bildName}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getStammdaten operation.
     * @callback module:api/DefaultApi~getStammdatenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StammdatenResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {Object} opts Optional parameters
     * @param {Boolean} [isMaKond] Gibt an, ob die Mitarbeiterkonditionen geholt werden sollen
     * @param {module:api/DefaultApi~getStammdatenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StammdatenResponse}
     */
  }, {
    key: "getStammdaten",
    value: function getStammdaten(mandantId, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getStammdaten");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'isMaKond': opts['isMaKond']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _StammdatenResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/stammdaten', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getTanAuthDaten operation.
     * @callback module:api/DefaultApi~getTanAuthDatenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/OrderStatus} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/TanAuthRequest} tanAuthRequest
     * @param {module:api/DefaultApi~getTanAuthDatenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/OrderStatus}
     */
  }, {
    key: "getTanAuthDaten",
    value: function getTanAuthDaten(mandantId, tanAuthRequest, callback) {
      var postBody = tanAuthRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling getTanAuthDaten");
      }
      // verify the required parameter 'tanAuthRequest' is set
      if (tanAuthRequest === undefined || tanAuthRequest === null) {
        throw new Error("Missing the required parameter 'tanAuthRequest' when calling getTanAuthDaten");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _OrderStatus.default;
      return this.apiClient.callApi('/rage/{mandantId}/tanAuth/Response', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the initSession operation.
     * @callback module:api/DefaultApi~initSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Session} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * init Sesson for VerseNeo
     * @param {Number} mandantId ID des Mandanten
     * @param {module:model/HeaderRequest} headerRequest
     * @param {module:api/DefaultApi~initSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Session}
     */
  }, {
    key: "initSession",
    value: function initSession(mandantId, headerRequest, callback) {
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling initSession");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling initSession");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Session.default;
      return this.apiClient.callApi('/rage/{mandantId}/session', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the postLieferadresse operation.
     * @callback module:api/DefaultApi~postLieferadresseCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HeaderResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Ändere einzelne Werte einer Lieferadresse
     * Wird in den Verwaltungsfunktionen dazu verwendet, einzelner Attribute einer Lieferadresse zu ändern
     * @param {Number} lieferadressenNummer ID der Lieferadresse
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/FilialeLieferadresseChange} filialeLieferadresseChange
     * @param {Object} opts Optional parameters
     * @param {String} [request] Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~postLieferadresseCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/HeaderResponse}
     */
  }, {
    key: "postLieferadresse",
    value: function postLieferadresse(lieferadressenNummer, mandantId, filialeLieferadresseChange, opts, callback) {
      opts = opts || {};
      var postBody = filialeLieferadresseChange;
      // verify the required parameter 'lieferadressenNummer' is set
      if (lieferadressenNummer === undefined || lieferadressenNummer === null) {
        throw new Error("Missing the required parameter 'lieferadressenNummer' when calling postLieferadresse");
      }
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling postLieferadresse");
      }
      // verify the required parameter 'filialeLieferadresseChange' is set
      if (filialeLieferadresseChange === undefined || filialeLieferadresseChange === null) {
        throw new Error("Missing the required parameter 'filialeLieferadresseChange' when calling postLieferadresse");
      }
      var pathParams = {
        'lieferadressenNummer': lieferadressenNummer,
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {
        'request': opts['request']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _HeaderResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/lieferadressen/{lieferadressenNummer}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the postLogin operation.
     * @callback module:api/DefaultApi~postLoginCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LogonClientNext} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Login User mit Passwort
     * @param {Number} mandantId
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:model/Login} login
     * @param {module:api/DefaultApi~postLoginCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LogonClientNext}
     */
  }, {
    key: "postLogin",
    value: function postLogin(mandantId, request, login, callback) {
      var postBody = login;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling postLogin");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling postLogin");
      }
      // verify the required parameter 'login' is set
      if (login === undefined || login === null) {
        throw new Error("Missing the required parameter 'login' when calling postLogin");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _LogonClientNext.default;
      return this.apiClient.callApi('/rage/{mandantId}/logonClientNext', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the puSoKurs operation.
     * @callback module:api/DefaultApi~puSoKursCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SortenKursResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die Kursliste der Sorten
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:api/DefaultApi~puSoKursCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SortenKursResponse}
     */
  }, {
    key: "puSoKurs",
    value: function puSoKurs(mandantId, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling puSoKurs");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SortenKursResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/kurs', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putAuftrag operation.
     * @callback module:api/DefaultApi~putAuftragCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AuftragResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die Details eines Auftrags für VerSEneo
     * @param {Number} mandantId ID des Mandanten
     * @param {Number} auftragsNummer ID des Auftrags
     * @param {module:model/HeaderRequest} headerRequest
     * @param {Object} opts Optional parameters
     * @param {String} [request] Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~putAuftragCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AuftragResponse}
     */
  }, {
    key: "putAuftrag",
    value: function putAuftrag(mandantId, auftragsNummer, headerRequest, opts, callback) {
      opts = opts || {};
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putAuftrag");
      }
      // verify the required parameter 'auftragsNummer' is set
      if (auftragsNummer === undefined || auftragsNummer === null) {
        throw new Error("Missing the required parameter 'auftragsNummer' when calling putAuftrag");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putAuftrag");
      }
      var pathParams = {
        'mandantId': mandantId,
        'auftragsNummer': auftragsNummer
      };
      var queryParams = {};
      var headerParams = {
        'request': opts['request']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AuftragResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/auftrag/{auftragsNummer}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putAuftragList operation.
     * @callback module:api/DefaultApi~putAuftragListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Auftragsliste} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die Aufträge für VerSEneo
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/HeaderRequest} headerRequest
     * @param {Object} opts Optional parameters
     * @param {String} [kennziffer] ID aus dem Katalog der Edelmetalle bzw. Sorten (KENNZ)
     * @param {String} [iso] ISO Code einer Währung bei Sorten. Die möglichen Ausprägungen werden aus der DB geliefert (ISOCODE) nur bei VerseNeo
     * @param {String} [text] Langbezeichnug des Produkts (LANGTEXT) nur bei VerseNeo. 30 Zeichen
     * @param {Number} [auftragsStatus] aktueller Status des Auftrags (AUFTRAGSTATUS) 1             Order erfasst, Ware noch nicht geliefert (bei Ankäufen) 2             Order bereit zur Abrechnung 3             Order an secore übertragen 4             Abrechnung in secore fehlerhaft 5             Order in secore erfolgreich abgerechnet 6             Storno durchgeführt      9             vorgemerkt zum Storno intern bei der BayernLB 70           TCM-Prüfung läuft 71           gesperrt wg. TCM-Prüfung
     * @param {module:model/String} [geschaeftsart] Ankauf oder Verkauf bei Edelmetall oder Sorten (GVARTNR)
     * @param {String} [kundenkonto] Kontonummer des Kunden (KONTO)
     * @param {Date} [datumVon] Startdatum der Suche (DATUMVON)
     * @param {Date} [datumBis] Endedatum der Suche (DATUMBIS)
     * @param {Number} [euroVon] Untere Grenze für den Euro-Gegenwert des Auftrags (VONBETR) nur bei VerseNeo
     * @param {Number} [euroBis] Obere Grenze für den Euro-Gegenwert des Auftrags (BISBETR) nur bei VerseNeo
     * @param {Number} [auftragsNummer] Nummer des Auftrags (AUFTRAGNR)
     * @param {Number} [auftragsNummerStart] die Auftragsnummer ist größer oder gleich der Nummer (START_AUFTRAG) nur bei VerseNeo
     * @param {String} [personenNummer] // Nummer der Person, für die der Auftrag gesucht werden soll
     * @param {String} [erfasserFiliale] // ID der Filiale, in der die gesuchten Aufträge erfasst wurden     
     * @param {String} [iban] // IBAN des Kundenkontos
     * @param {String} [request] Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~putAuftragListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Auftragsliste}
     */
  }, {
    key: "putAuftragList",
    value: function putAuftragList(mandantId, headerRequest, opts, callback) {
      opts = opts || {};
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putAuftragList");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putAuftragList");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'kennziffer': opts['kennziffer'],
        'iso': opts['iso'],
        'text': opts['text'],
        'auftragsStatus': opts['auftragsStatus'],
        'geschaeftsart': opts['geschaeftsart'],
        'kundenkonto': opts['kundenkonto'],
        'datumVon': opts['datumVon'],
        'datumBis': opts['datumBis'],
        'euroVon': opts['euroVon'],
        'euroBis': opts['euroBis'],
        'auftragsNummer': opts['auftragsNummer'],
        'auftragsNummerStart': opts['auftragsNummerStart'],
        'personenNummer': opts['personenNummer'],
        'erfasserFiliale': opts['erfasserFiliale'],
        'iban': opts['iban']
      };
      var headerParams = {
        'request': opts['request']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Auftragsliste.default;
      return this.apiClient.callApi('/rage/{mandantId}/auftragsuebersicht', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putAuftragPdf operation.
     * @callback module:api/DefaultApi~putAuftragPdfCallback
     * @param {String} error Error message, if any.
     * @param {Blob} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die zum Mandanten gehörende PDF für einen Auftrag in VerSEneo
     * @param {Number} mandantId ID des Mandanten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {Number} auftragsNummer ID des Auftrags
     * @param {module:model/HeaderRequest} headerRequest
     * @param {module:api/DefaultApi~putAuftragPdfCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Blob}
     */
  }, {
    key: "putAuftragPdf",
    value: function putAuftragPdf(mandantId, request, auftragsNummer, headerRequest, callback) {
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putAuftragPdf");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling putAuftragPdf");
      }
      // verify the required parameter 'auftragsNummer' is set
      if (auftragsNummer === undefined || auftragsNummer === null) {
        throw new Error("Missing the required parameter 'auftragsNummer' when calling putAuftragPdf");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putAuftragPdf");
      }
      var pathParams = {
        'mandantId': mandantId,
        'auftragsNummer': auftragsNummer
      };
      var queryParams = {};
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/pdf'];
      var returnType = 'Blob';
      return this.apiClient.callApi('/rage/{mandantId}/auftragPdf/{auftragsNummer}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putEmKonditionen operation.
     * @callback module:api/DefaultApi~putEmKonditionenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EdelmetallKonditionen} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * hole Konditionen für VerSEneo
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/HeaderRequest} headerRequest
     * @param {Object} opts Optional parameters
     * @param {String} [request] Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~putEmKonditionenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EdelmetallKonditionen}
     */
  }, {
    key: "putEmKonditionen",
    value: function putEmKonditionen(mandantId, headerRequest, opts, callback) {
      opts = opts || {};
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putEmKonditionen");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putEmKonditionen");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {
        'request': opts['request']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _EdelmetallKonditionen.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/konditionenProdukt', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putEmKonditionenStufen operation.
     * @callback module:api/DefaultApi~putEmKonditionenStufenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EdelmetallKonditionenStufen} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * hole Konditionen Stufen für VerSEneo
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/HeaderRequest} headerRequest
     * @param {module:api/DefaultApi~putEmKonditionenStufenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EdelmetallKonditionenStufen}
     */
  }, {
    key: "putEmKonditionenStufen",
    value: function putEmKonditionenStufen(mandantId, headerRequest, callback) {
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putEmKonditionenStufen");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putEmKonditionenStufen");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _EdelmetallKonditionenStufen.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/konditionenStufen', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putEmKursList operation.
     * @callback module:api/DefaultApi~putEmKursListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Kursliste} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die Kursliste für VerSEneo
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/HeaderRequest} headerRequest
     * @param {Object} opts Optional parameters
     * @param {String} [request] Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~putEmKursListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Kursliste}
     */
  }, {
    key: "putEmKursList",
    value: function putEmKursList(mandantId, headerRequest, opts, callback) {
      opts = opts || {};
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putEmKursList");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putEmKursList");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {
        'request': opts['request']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Kursliste.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/kursListe', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putEmKursListePdf operation.
     * @callback module:api/DefaultApi~putEmKursListePdfCallback
     * @param {String} error Error message, if any.
     * @param {Blob} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die zum Mandanten gehörende Kursliste als PDF für VerSEneo
     * @param {Number} mandantId ID des Mandanten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:model/HeaderRequest} headerRequest
     * @param {Object} opts Optional parameters
     * @param {String} [kind] Filter by kind (Metallart)
     * @param {String} [make] Filter by make (Ausführung)
     * @param {module:api/DefaultApi~putEmKursListePdfCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Blob}
     */
  }, {
    key: "putEmKursListePdf",
    value: function putEmKursListePdf(mandantId, request, headerRequest, opts, callback) {
      opts = opts || {};
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putEmKursListePdf");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling putEmKursListePdf");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putEmKursListePdf");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'kind': opts['kind'],
        'make': opts['make']
      };
      console.log('DefaultApi.putEmKursListePdf - opts:', opts, 'queryParams:', queryParams);
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/pdf'];
      var returnType = 'Blob';
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/kursListePdf', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putEmPreis operation.
     * @callback module:api/DefaultApi~putEmPreisCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EdelmetallPreisResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die Preisliste der Edelmetalle
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/MitarbeiterKonditionenRequest} mitarbeiterKonditionenRequest
     * @param {module:api/DefaultApi~putEmPreisCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EdelmetallPreisResponse}
     */
  }, {
    key: "putEmPreis",
    value: function putEmPreis(mandantId, mitarbeiterKonditionenRequest, callback) {
      var postBody = mitarbeiterKonditionenRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putEmPreis");
      }
      // verify the required parameter 'mitarbeiterKonditionenRequest' is set
      if (mitarbeiterKonditionenRequest === undefined || mitarbeiterKonditionenRequest === null) {
        throw new Error("Missing the required parameter 'mitarbeiterKonditionenRequest' when calling putEmPreis");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _EdelmetallPreisResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/preis', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putLieferadressenList operation.
     * @callback module:api/DefaultApi~putLieferadressenListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FilialenListe} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die Lieferadressen für VerSEneo
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/HeaderRequest} headerRequest
     * @param {Object} opts Optional parameters
     * @param {String} [kennziffer] ID aus dem Katalog der Edelmetalle bzw. Sorten (KENNZ)
     * @param {String} [iso] ISO Code einer Währung bei Sorten. Die möglichen Ausprägungen werden aus der DB geliefert (ISOCODE) nur bei VerseNeo
     * @param {String} [text] Langbezeichnug des Produkts (LANGTEXT) nur bei VerseNeo. 30 Zeichen
     * @param {Number} [auftragsStatus] aktueller Status des Auftrags (AUFTRAGSTATUS) 1             Order erfasst, Ware noch nicht geliefert (bei Ankäufen) 2             Order bereit zur Abrechnung 3             Order an secore übertragen 4             Abrechnung in secore fehlerhaft 5             Order in secore erfolgreich abgerechnet 6             Storno durchgeführt      9             vorgemerkt zum Storno intern bei der BayernLB 70           TCM-Prüfung läuft 71           gesperrt wg. TCM-Prüfung
     * @param {module:model/String} [geschaeftsart] Ankauf oder Verkauf bei Edelmetall oder Sorten (GVARTNR)
     * @param {String} [kundenkonto] Kontonummer des Kunden (KONTO)
     * @param {Date} [datumVon] Startdatum der Suche (DATUMVON)
     * @param {Date} [datumBis] Endedatum der Suche (DATUMBIS)
     * @param {Number} [euroVon] Untere Grenze für den Euro-Gegenwert des Auftrags (VONBETR) nur bei VerseNeo
     * @param {Number} [euroBis] Obere Grenze für den Euro-Gegenwert des Auftrags (BISBETR) nur bei VerseNeo
     * @param {Number} [auftragsNummer] Nummer des Auftrags (AUFTRAGNR)
     * @param {Number} [auftragsNummerStart] die Auftragsnummer ist größer oder gleich der Nummer (START_AUFTRAG) nur bei VerseNeo
     * @param {String} [request] Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~putLieferadressenListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FilialenListe}
     */
  }, {
    key: "putLieferadressenList",
    value: function putLieferadressenList(mandantId, headerRequest, opts, callback) {
      opts = opts || {};
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putLieferadressenList");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putLieferadressenList");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'kennziffer': opts['kennziffer'],
        'iso': opts['iso'],
        'text': opts['text'],
        'auftragsStatus': opts['auftragsStatus'],
        'geschaeftsart': opts['geschaeftsart'],
        'kundenkonto': opts['kundenkonto'],
        'datumVon': opts['datumVon'],
        'datumBis': opts['datumBis'],
        'euroVon': opts['euroVon'],
        'euroBis': opts['euroBis'],
        'auftragsNummer': opts['auftragsNummer'],
        'auftragsNummerStart': opts['auftragsNummerStart']
      };
      var headerParams = {
        'request': opts['request']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _FilialenListe.default;
      return this.apiClient.callApi('/rage/{mandantId}/lieferadressen', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putOrderPdf operation.
     * @callback module:api/DefaultApi~putOrderPdfCallback
     * @param {String} error Error message, if any.
     * @param {Blob} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die zur Order gehörende PDF in VerSEneo
     * @param {Number} orderId Kennung der order
     * @param {Number} mandantId ID des Mandanten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:model/HeaderRequest} headerRequest
     * @param {module:api/DefaultApi~putOrderPdfCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Blob}
     */
  }, {
    key: "putOrderPdf",
    value: function putOrderPdf(orderId, mandantId, request, headerRequest, callback) {
      var postBody = headerRequest;
      // verify the required parameter 'orderId' is set
      if (orderId === undefined || orderId === null) {
        throw new Error("Missing the required parameter 'orderId' when calling putOrderPdf");
      }
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putOrderPdf");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling putOrderPdf");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putOrderPdf");
      }
      var pathParams = {
        'orderId': orderId,
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/pdf'];
      var returnType = 'Blob';
      return this.apiClient.callApi('/rage/{mandantId}/order/orderPdf/{orderId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putSoKonditionen operation.
     * @callback module:api/DefaultApi~putSoKonditionenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SortenKonditionen} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Hole Konditionen für Sorten für VerSEneo
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/HeaderRequest} headerRequest
     * @param {module:api/DefaultApi~putSoKonditionenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SortenKonditionen}
     */
  }, {
    key: "putSoKonditionen",
    value: function putSoKonditionen(mandantId, headerRequest, callback) {
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putSoKonditionen");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putSoKonditionen");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _SortenKonditionen.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/konditionenProdukt', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putSoKonditionenStufen operation.
     * @callback module:api/DefaultApi~putSoKonditionenStufenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SortenKonditionenStufen} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * hole Konditionen von Sorten für VerSEneo
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/HeaderRequest} headerRequest
     * @param {module:api/DefaultApi~putSoKonditionenStufenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SortenKonditionenStufen}
     */
  }, {
    key: "putSoKonditionenStufen",
    value: function putSoKonditionenStufen(mandantId, headerRequest, callback) {
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putSoKonditionenStufen");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putSoKonditionenStufen");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _SortenKonditionenStufen.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/konditionenStufen', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putSoKursList operation.
     * @callback module:api/DefaultApi~putSoKursListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Kursliste} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die Kursliste für VerSEneo
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/HeaderRequest} headerRequest
     * @param {Object} opts Optional parameters
     * @param {String} [request] Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~putSoKursListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Kursliste}
     */
  }, {
    key: "putSoKursList",
    value: function putSoKursList(mandantId, headerRequest, opts, callback) {
      opts = opts || {};
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putSoKursList");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putSoKursList");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {
        'request': opts['request']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Kursliste.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/kursListe', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putSoKursListePdf operation.
     * @callback module:api/DefaultApi~putSoKursListePdfCallback
     * @param {String} error Error message, if any.
     * @param {Blob} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die zum Mandanten gehörende Kursliste als PDF für VerSEneo
     * @param {Number} mandantId ID des Mandanten
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:model/HeaderRequest} headerRequest
     * @param {Object} opts Optional parameters
     * @param {String} [kind] Filter by kind (Metallart)
     * @param {String} [make] Filter by make (Ausführung)
     * @param {module:api/DefaultApi~putSoKursListePdfCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Blob}
     */
  }, {
    key: "putSoKursListePdf",
    value: function putSoKursListePdf(mandantId, request, headerRequest, opts, callback) {
      opts = opts || {};
      var postBody = headerRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putSoKursListePdf");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling putSoKursListePdf");
      }
      // verify the required parameter 'headerRequest' is set
      if (headerRequest === undefined || headerRequest === null) {
        throw new Error("Missing the required parameter 'headerRequest' when calling putSoKursListePdf");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {
        'kind': opts['kind'],
        'make': opts['make']
      };
      console.log('DefaultApi.putSoKursListePdf - opts:', opts, 'queryParams:', queryParams);
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/pdf'];
      var returnType = 'Blob';
      return this.apiClient.callApi('/rage/{mandantId}/sorten/kursListePdf', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the putStammdaten operation.
     * @callback module:api/DefaultApi~putStammdatenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StammdatenResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * holt die Stammdaten für VerseNeo
     * Abfrage der Stammdaten (Gebühren/Filialen) eines Mandanten
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/MitarbeiterKonditionenRequest} mitarbeiterKonditionenRequest
     * @param {module:api/DefaultApi~putStammdatenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StammdatenResponse}
     */
  }, {
    key: "putStammdaten",
    value: function putStammdaten(mandantId, mitarbeiterKonditionenRequest, callback) {
      var postBody = mitarbeiterKonditionenRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling putStammdaten");
      }
      // verify the required parameter 'mitarbeiterKonditionenRequest' is set
      if (mitarbeiterKonditionenRequest === undefined || mitarbeiterKonditionenRequest === null) {
        throw new Error("Missing the required parameter 'mitarbeiterKonditionenRequest' when calling putStammdaten");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _StammdatenResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/stammdaten', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the setEmWarenkorb operation.
     * @callback module:api/DefaultApi~setEmWarenkorbCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EdelmetallWarenkorbResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/EdelmetallWarenkorb} edelmetallWarenkorb
     * @param {module:api/DefaultApi~setEmWarenkorbCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EdelmetallWarenkorbResponse}
     */
  }, {
    key: "setEmWarenkorb",
    value: function setEmWarenkorb(mandantId, edelmetallWarenkorb, callback) {
      var postBody = edelmetallWarenkorb;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling setEmWarenkorb");
      }
      // verify the required parameter 'edelmetallWarenkorb' is set
      if (edelmetallWarenkorb === undefined || edelmetallWarenkorb === null) {
        throw new Error("Missing the required parameter 'edelmetallWarenkorb' when calling setEmWarenkorb");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _EdelmetallWarenkorbResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/edelmetall/warenkorb', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the setMandantByGp operation.
     * @callback module:api/DefaultApi~setMandantByGpCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HeaderResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * ändere die Mandantdaten
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {String} gpNummer GP Nummer des Mandanten
     * @param {module:model/MandantRequest} mandantRequest
     * @param {module:api/DefaultApi~setMandantByGpCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/HeaderResponse}
     */
  }, {
    key: "setMandantByGp",
    value: function setMandantByGp(mandantId, gpNummer, mandantRequest, callback) {
      var postBody = mandantRequest;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling setMandantByGp");
      }
      // verify the required parameter 'gpNummer' is set
      if (gpNummer === undefined || gpNummer === null) {
        throw new Error("Missing the required parameter 'gpNummer' when calling setMandantByGp");
      }
      // verify the required parameter 'mandantRequest' is set
      if (mandantRequest === undefined || mandantRequest === null) {
        throw new Error("Missing the required parameter 'mandantRequest' when calling setMandantByGp");
      }
      var pathParams = {
        'mandantId': mandantId,
        'GpNummer': gpNummer
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _HeaderResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/mandant/{GpNummer}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the setSoWarenkorb operation.
     * @callback module:api/DefaultApi~setSoWarenkorbCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SortenWarenkorbResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * to be added
     * @param {Number} mandantId ID des aktuellen Mandaten
     * @param {module:model/SortenWarenkorb} sortenWarenkorb
     * @param {module:api/DefaultApi~setSoWarenkorbCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SortenWarenkorbResponse}
     */
  }, {
    key: "setSoWarenkorb",
    value: function setSoWarenkorb(mandantId, sortenWarenkorb, callback) {
      var postBody = sortenWarenkorb;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling setSoWarenkorb");
      }
      // verify the required parameter 'sortenWarenkorb' is set
      if (sortenWarenkorb === undefined || sortenWarenkorb === null) {
        throw new Error("Missing the required parameter 'sortenWarenkorb' when calling setSoWarenkorb");
      }
      var pathParams = {
        'mandantId': mandantId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _SortenWarenkorbResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/sorten/warenkorb', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the startMailversandTls operation.
     * @callback module:api/DefaultApi~startMailversandTlsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HeaderResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * trigger den Mailversand des TLS Codes
     * @param {Number} mandantId ID des Mandanten
     * @param {Number} angebotsId Nummer des Angebots aus /warenkorb
     * @param {String} request Zusätzliche Informationen im HTTP Header als stringified RequestHeader
     * @param {module:api/DefaultApi~startMailversandTlsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/HeaderResponse}
     */
  }, {
    key: "startMailversandTls",
    value: function startMailversandTls(mandantId, angebotsId, request, callback) {
      var postBody = null;
      // verify the required parameter 'mandantId' is set
      if (mandantId === undefined || mandantId === null) {
        throw new Error("Missing the required parameter 'mandantId' when calling startMailversandTls");
      }
      // verify the required parameter 'angebotsId' is set
      if (angebotsId === undefined || angebotsId === null) {
        throw new Error("Missing the required parameter 'angebotsId' when calling startMailversandTls");
      }
      // verify the required parameter 'request' is set
      if (request === undefined || request === null) {
        throw new Error("Missing the required parameter 'request' when calling startMailversandTls");
      }
      var pathParams = {
        'mandantId': mandantId,
        'angebotsId': angebotsId
      };
      var queryParams = {};
      var headerParams = {
        'request': request
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _HeaderResponse.default;
      return this.apiClient.callApi('/rage/{mandantId}/mailversandTls/{angebotsId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);
}();